import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/apiClient";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenido a Sistemas");
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (

    <div className="min-h-screen flex">
      {/* Left brand panel */}
      <div className="hidden lg:flex w-1/2 bg-slate-950 text-white flex-col justify-between p-14 relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)", backgroundSize: "40px 40px" }} />
        <div className="relative flex items-center gap-3">
          <img src="/zae-logo.png" alt="ZAE" className="h-10 w-10 object-contain" />
          <span className="font-heading font-extrabold text-2xl tracking-tight">Sistemas</span>
        </div>
        <div className="relative">
          <h1 className="font-heading text-5xl font-extrabold leading-[1.05] tracking-tighter">
            Gestión inteligente<br />de proyectos de<br />desarrollo.
          </h1>
          <p className="mt-6 text-slate-400 text-base max-w-md leading-relaxed">
            Dashboard ejecutivo tipo Kanban con priorización automática, alertas inteligentes y control del ciclo completo: Análisis → Desarrollo → Pruebas → Deploy → Producción.
          </p>
        </div>
        <div className="relative flex gap-8 text-sm">
          <div><div className="font-heading text-3xl font-bold">9</div><div className="text-slate-400 uppercase text-[11px] tracking-widest mt-1">Estados</div></div>
          <div><div className="font-heading text-3xl font-bold">5</div><div className="text-slate-400 uppercase text-[11px] tracking-widest mt-1">Reglas de alerta</div></div>
          <div><div className="font-heading text-3xl font-bold">4</div><div className="text-slate-400 uppercase text-[11px] tracking-widest mt-1">Roles</div></div>
        </div>
      </div>

      {/* Right form */}
      <div className="flex-1 flex items-center justify-center p-6 bg-[#FAFAFA]">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-2 mb-8">
            <div className="h-8 w-8 bg-slate-900 flex items-center justify-center rounded-sm"><img src="/zae-logo.png" alt="ZAE" className="h-6 w-6 object-contain" /></div>
            <span className="font-heading font-extrabold text-xl">ZAE Corporativo</span>
          </div>
          <h2 className="font-heading text-3xl font-extrabold tracking-tight">Iniciar sesión</h2>
          <p className="text-slate-500 text-sm mt-1">Accede a tu panel según tu rol.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label htmlFor="email" className="text-xs font-semibold uppercase tracking-wider text-slate-500">Correo</Label>
              <Input data-testid="login-email" id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 rounded-sm border-slate-300 focus-visible:ring-slate-900" placeholder="tu@empresa.com" />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs font-semibold uppercase tracking-wider text-slate-500">Contraseña</Label>
              <Input data-testid="login-password" id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5 rounded-sm border-slate-300 focus-visible:ring-slate-900" placeholder="••••••••" />
            </div>
            {error && <p data-testid="login-error" className="text-sm text-red-600">{error}</p>}
            <Button data-testid="login-submit" type="submit" disabled={loading}
              className="w-full rounded-sm bg-slate-900 hover:bg-slate-800 text-white h-11 font-semibold">
              {loading ? "Ingresando..." : "Ingresar"} <ArrowRight className="h-4 w-4 ml-1" />
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
